export default function ModalFooter({ className }: { className: string }) {
  return (
    <footer
      className={`flex flex-col items-center text-opaque-navy bg-white border-t-0 p-t-0 ${className}`}
    >
      <div className="flex flex-col items-center text-center">
        <div>
          <p>
            Credit Key is not a bank. Certain business-purpose loans made by Lead Bank
            and subject to credit approval. Personal guaranty may be required. Borrower
            must be a valid business in good standing. Fees vary based on loan amount.
          </p>
        </div>
        <div className="flex justify-between divide-x my-4">
          <a
            href="https://www.creditkey.com/legal/privacy-policy"
            target="_blank"
            rel="noreferrer"
            className="px-2 no-underline hover:text-primary-blue whitespace-nowrap"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.creditkey.com/legal/terms-of-service-and-electronic-disclosures"
            target="_blank"
            rel="noreferrer"
            className="px-2 no-underline hover:text-primary-blue whitespace-nowrap"
          >
            Terms of Service
          </a>
          <a
            href="https://lead.bank/privacy-and-terms"
            target="_blank"
            rel="noreferrer"
            className="px-2 no-underline hover:text-primary-blue whitespace-nowrap"
          >
            Lead Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}
